import React from 'react'

export default function ArrowIco({ active = false }) {
  return (
    <svg
      width="10"
      height="6"
      viewBox="0 0 10 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.59375 1.11609L4.79764 5.33559L9.00153 1.11609"
        stroke={active ? '#3249D7' : '#4B465C'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
